/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-06 11:39:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { getFormValues } from 'redux-form';

import RuleBasedItem from 'src/components/views/recommendation/widget/item/general/rule-based-item';

import type { RuleType } from 'src/models/recommendation';
import type { RecommendationWidgetType } from 'src/models/recommendation';
import type { FormProps } from 'redux-form';

type State = { metafields: Array<any> };

type Props = {
  rule: RuleType,
  dragHandleProps: DraggableProvidedDragHandleProps,
  formValues: RecommendationWidgetType,
  updateField: Function,
  host: string
};

type PropsFromState = {
  success: boolean,
  collections: Array<{ value: string, label: string }>,
  metafieldList: Array<string>,
  filterData: Object
};

type ComposedProps = WithI18nProps & Props & PropsFromState & FormProps;

class RuleBasedItemContainer extends Component<ComposedProps, State> {
  state = {
    metafields: []
  };

  componentDidMount() {
    const { success, metafieldList } = this.props;
    if (success) {
      let metafields = this.buildMetafieldOptions(metafieldList);
      this.setState({ metafields });
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const { success } = this.props;
    const { success: nextSuccess, metafieldList: nextMetafields } = nextProps;
    // Check when the component is loaded before API finish
    if (success !== nextSuccess && nextSuccess === true) {
      let metafields = this.buildMetafieldOptions(nextMetafields);
      this.setState({ metafields });
    }
  }

  render() {
    const { metafields } = this.state;
    return <RuleBasedItem {...this.props} metafields={metafields} />;
  }

  buildMetafieldOptions = (metafieldList: Array<Object>) => {
    let result = [];
    if (_.isArray(metafieldList)) {
      if (metafieldList.length > 0) {
        metafieldList.forEach(item => {
          const split = item.split('::');
          const namespace = split[1];
          const key = split[2];

          result.push({
            value: item,
            label: `${namespace}.${key}`,
            namespace,
            key
          });
        });
      }
    }
    return result;
  };
}

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('RecommendationGeneralWidgetItemForm')(state);

  return {
    success: _.get(state.filterData, 'success', false),
    collections: _.get(state.filterData.filterData, 'collections', []),
    metafieldList: _.get(state.filterData.filterData, 'metafieldList', []),
    filterData: _.get(state.filterData, 'filterData', {}),
    host: _.get(state.oauth, 'host', ''),
    formValues: formValues || {}
  };
};

export default withI18n()(connect(mapStateToProps, {})(RuleBasedItemContainer));
